import { createReducer } from 'lib/utilities.js';

const initialState = {
  responseTimes: [],
  insightsPipelineLeadData: [],
  revenueInsights: [],
  responseTimeLoadState: false,
  pipelineLeadInsightsLoadState: false,
};

export default createReducer(initialState, {
  GET_RESPONSE_TIME_AGGREGATE_SUCCESS: (state, payload) => ({
    ...state,
    responseTimes: (payload.data || []).flat(),
    responseTimeLoadState: false,
  }),
  REVENUE_INSIGHTS_DATA_SUCCESS: (state, payload) => ({
    ...state,
    revenueInsights: (payload.data || []).flat(),
    pipelineLeadInsightsLoadState: false,
  }),
  GET_INSIGHTS_PIPELINE_LEAD_DATA_SUCCESS: (state, payload) => ({
    ...state,
    insightsPipelineLeadData: (payload.data || []).flat(),
    pipelineLeadInsightsLoadState: false,
  }),
  SET_INSIGHTS_LOAD_STATE: (state, payload) => ({
    ...state,
    [payload.key]: payload.value,
  }),
});
